export const checkinKeys = {
    all: ['checkin'] as const,
    today: (centerId: string) => [...checkinKeys.all, 'today', centerId] as const,
    logs: (centerId: string) => [...checkinKeys.all, 'logs', centerId] as const,
};
